module.exports = __webpack_public_path__ + "static/media/drone_mascot.fc57e2a0.zip";